import { FeedbackData, FeedbackType } from 'src/api/feedback';

export enum FeedbackPageMode {
  Actual = 'actual',
  Resolved = 'resolved',
}

export interface FeedbackState {
  loading: boolean;
  error?: string;
  feedbackType: FeedbackType;
  mode?: FeedbackPageMode | undefined;
  rows: FeedbackData[];
  hasMore: boolean;
  pageNumber: number;
  currentRequestId: string | undefined;
  comment: string;
  currentFeedbackId?: number;
}
